<template>
  <!-- 删除小标题 -->
  <!-- <div v-if="isWeb && !hideBar && visible" -->
  <div v-if="false"
       class="down-load-guide-bar"
  >``
    <ym-img class="icon"
            :src="downloadBarInfo.icon"
    />
    <div class="info">
      <div class="title">{{ downloadBarInfo.title }}</div>
      <div class="summary">{{ downloadBarInfo.desc }}</div>
    </div>
    <div class="down-load"
         v-ym-report:GROWTH_DOWNLOAD_APP_BAR_DOWNLOAD_CLICK=""
         @click="handleLinkToDownloadPage"
    >
      下载APP
    </div>

    <ym-img class="cancel"
            :src="require('@/assets/img/download_guide/cancel.png')"
            v-ym-report:GROWTH_DOWNLOAD_APP_BAR_DOWNLOAD_CLOSE_CLICK=""
            @click="handleClose"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {
    setToLocalStorage,
    getFromLocalStorage,
    removeFromLocalStorage,
    isWeb,
    setDownloadBarHeight,
  } from '@/utils';

  export default {
    name: 'DownLoadGuideBar',
    data() {
      return {
        isWeb: isWeb(),
        visible: false,
        dayTimeStamp: 86400 * 1000,
      };
    },
    props: {
      hideBar: {
        type: Boolean,
        default: false,
      },
      height: {
        type: [Number, String],
        default: 100,
      },
    },
    watch: {
      visible(val) {
        if (!val) {
          // 通知外层下载栏已隐藏
          this.$emit('download-bar-hidden');
          setDownloadBarHeight(0);
          return;
        }
        setDownloadBarHeight(this.height);
      },
      $route() {
        this.fetchShowDownloadBar();
      },
      height(val) {
        setDownloadBarHeight(val);
      },
    },
    computed: {
      ...mapGetters([
        'downloadBarInfo',
      ]),
    },
    methods: {
      getDownloadStorage() {
        return JSON.parse(getFromLocalStorage(this.downloadBarInfo.key));
      },
      fetchShowDownloadBar() {
        if (this.hideBar) {
          this.visible = false;
          return;
        }
        if (!this.downloadBarInfo) {
          this.visible = false;
          return;
        }
        const storage = this.getDownloadStorage();
        // 缓存不存在，展示引导栏
        if (!storage) {
          this.visible = true;
          return;
        }
        // 是否是同一个活动
        if (this.downloadBarInfo.key !== storage.key) {
          removeFromLocalStorage(storage.key);
          this.visible = true;
          return;
        }
        // 是否已经关闭过三次
        if (storage.closeTime >= 3) return;
        // 判断展示间隔
        this.fetchShowBarInterval(storage);
      },
      fetchShowBarInterval(storage) {
        const { closeTime, startTime, type } = storage;
        const currTime = new Date().getTime();
        const interval = currTime - startTime;

        // eslint-disable-next-line no-sequences
        switch (closeTime, type) {
          case 1: {
            // 判断间隔是否大于1天
            const timeStamp = type === 'close' ? this.dayTimeStamp : (this.dayTimeStamp * 7);
            this.visible = Boolean(interval > timeStamp);
            return;
          }
          case 2: {
            // 判断间隔是否大于7天
            this.visible = Boolean(interval > this.dayTimeStamp * 7);
            return;
          }
          default: {
            this.visible = false;
          }
        }
      },
      handleClose() {
        const storage = this.getDownloadStorage();
        const currTime = new Date().getTime();
        let params = {};
        if (!storage) {
          params = {
            key: this.downloadBarInfo.key,
            startTime: currTime,
            closeTime: 1,
            type: 'close',
          };
        } else {
          storage.closeTime += 1;
          storage.startTime = currTime;
          params = storage;
        }
        setToLocalStorage(this.downloadBarInfo.key, JSON.stringify(params));
        this.visible = false;
      },
      handleLinkToDownloadPage() {
        const route = {
          name: 'DownLoad',
          query: {
            key: 'downLoadGuide',
          },
        };
        this.$router.push(route);
        this.visible = false;
      },
    },
    created() {
      this.fetchShowDownloadBar();
      setDownloadBarHeight(0);
      this.$emit('download-bar-exit', this.visible);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .down-load-guide-bar {
    width: 100%;
    height: 100px;
    background: linear-gradient(315deg, #D9F8F7 0%, #F0FCFC 100%);
    background-size: cover;
    position: relative;
  }

  .down-load {
    position: absolute;
    right: @size-extra-medium;
    top: 25px;
    box-sizing: border-box;
    line-height: normal;
    border-radius: 34px;
    width: 160px;
    height: @size-extra-medium;
    background: linear-gradient(270deg, @color-gradient-primary-1 0%,
      @color-gradient-primary-2 100%);
    text-align: center;
    padding-top: 6px;
    font-size: @font-size-base;
    color: @color-white;
  }

  .cancel {
    position: absolute;
    top: 5px;
    right: 5px;
    width: @size-medium;
    height: @size-medium;
  }

  .icon {
    width: 80px;
    height: 80px;
    position: absolute;
    left: 40px;
    top: 10px;
    border-radius: 8px;
  }

  .info {
    position: absolute;
    top: 18px;
    left: 134px;
    .title {
      color: @color-black-dark;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      line-height: 1;
    }
    .summary {
      margin-top: 14px;
      font-size: @font-size-extra-small;
      color: @color-text-light;
      line-height: 1;
    }
  }
</style>
